import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles({
  dropdown: {
    width: 250,
  },
});
